import type { OrderType } from '~/services/api/generated'

export const OrderTypePresentation = {
  delivery: {
    label: 'Delivery',
    helpText: 'Deliver to your location'
  },
  pickup: {
    label: 'Pickup',
    helpText: 'Pick up from the restaurant'
  },
  dine_in: {
    label: 'Group Dining',
    helpText: 'Dine together at the restaurant'
  }
} satisfies Record<OrderType, { label: string; helpText: string }>
